import { ECOSYSTEM } from "@/content/site";
import { Reveal } from "./primitives";
import { ShieldCheck } from "lucide-react";

const Node = ({ n, className = "" }) => {
  const Icon = n.icon;
  return (
    <div data-testid={`eco-node-${n.key}`} className={`card-soft flex items-center gap-4 p-4 sm:p-5 ${className}`}>
      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
        <Icon className="h-5 w-5" strokeWidth={1.8} />
      </span>
      <div>
        <p className="font-display text-[15px] font-semibold text-plum sm:text-base">{n.label}</p>
        <p className="text-xs text-slate sm:text-sm">{n.note}</p>
      </div>
    </div>
  );
};

/** Patients → Community Centre (hub) → licensed clinical partners. */
export const EcosystemDiagram = () => {
  const [patients, hub, ...partners] = ECOSYSTEM;
  const HubIcon = hub.icon;
  return (
    <div data-testid="ecosystem-diagram" className="relative">
      <div className="grid items-center gap-6 lg:grid-cols-[1fr_auto_1.2fr_auto_1.4fr] lg:gap-0">
        <Reveal><Node n={patients} /></Reveal>

        <div aria-hidden="true" className="mx-auto h-10 w-px bg-gradient-to-b from-teal/10 to-teal lg:h-px lg:w-14 lg:bg-gradient-to-r" />

        <Reveal delay={0.1}>
          <div data-testid="eco-node-centre" className="relative overflow-hidden rounded-[1.75rem] bg-plum p-7 text-white shadow-[0_30px_60px_-30px_rgba(44,15,101,0.6)]">
            <img src="/logo-mark.png" alt="" aria-hidden="true" className="pointer-events-none absolute -right-8 -top-8 w-36 opacity-15" />
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white/10"><HubIcon className="h-6 w-6" strokeWidth={1.7} /></span>
            <p className="mt-5 font-display text-xl font-semibold text-white">{hub.label}</p>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wider text-teal-100">{hub.note}</p>
            <ul className="mt-4 space-y-1.5 text-sm text-white/75">
              <li>Registration & basic screening</li>
              <li>Teleconsultation support</li>
              <li>Coordination & follow-up</li>
            </ul>
          </div>
        </Reveal>

        <div aria-hidden="true" className="mx-auto h-10 w-px bg-gradient-to-b from-teal to-teal/10 lg:h-px lg:w-14 lg:bg-gradient-to-r" />

        <Reveal delay={0.2}>
          <div className="rounded-[1.75rem] border border-dashed border-teal/40 bg-white/70 p-4 sm:p-5">
            <p className="mb-4 flex items-center gap-2 px-1 text-xs font-semibold uppercase tracking-[0.16em] text-teal-700">
              <ShieldCheck className="h-4 w-4" /> Licensed clinical partners
            </p>
            <div className="grid gap-3">
              {partners.map((p) => <Node key={p.key} n={p} />)}
            </div>
            <p className="mt-4 px-1 text-xs leading-relaxed text-slate">All clinical decisions — diagnosis, prescriptions and treatment — remain with qualified, licensed professionals.</p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};
